import { useEffect, useSyncExternalStore } from "react";

export const createSuppressionStore = () => {
  const requests = new Set<symbol>();
  const listeners = new Set<() => void>();
  const getSnapshot = () => requests.size > 0;
  const getServerSnapshot = () => false;
  const notify = () => listeners.forEach((listener) => listener());
  const subscribe = (listener: () => void) => {
    listeners.add(listener);
    return () => {
      listeners.delete(listener);
    };
  };

  const useSuppressed = () => useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);

  const useSuppress = (hidden: boolean) => {
    useEffect(() => {
      if (!hidden) {
        return;
      }
      const request = Symbol();
      requests.add(request);
      notify();
      return () => {
        requests.delete(request);
        notify();
      };
    }, [hidden]);
  };

  return { useSuppressed, useSuppress };
};
